import { render, staticRenderFns } from "./StockLocation.vue?vue&type=template&id=cb1fd85a&scoped=true"
import script from "./StockLocation.vue?vue&type=script&lang=js"
export * from "./StockLocation.vue?vue&type=script&lang=js"
import style0 from "./StockLocation.vue?vue&type=style&index=0&id=cb1fd85a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb1fd85a",
  null
  
)

export default component.exports